const baseUrlSimpleClassZhihuishu = 'https://simple-class.zhihuishu.com/simple-class'

export default {
  // 登录
  login: {
    url: "/admin/login",
    method: "post"
  },
  // 登录2
  phoneLogin: {
    url: "/admin/phoneLogin",
    method: "post"
  },
  // 获取登录验证码
  sendValidCode: {
    url: "/admin/sendValidCode",
    method: "post"
  },
  // 获取用户信息
  getUserInfo: {
    url: "/admin/getUserInfo",
    method: "get"
  },
  // 新增教室
  addClassroom: {
    url: "/admin/classroom/add",
    method: "post"
  },
  // 教室详情
  getClassroomDetail: {
    url: "/admin/classroom/detail",
    method: "get"
  },
  // 编辑保存教室
  editClassrooom: {
    url: "/admin/classroom/edit",
    method: "post"
  },
  // 教室绑定设备
  bindClassroomDevice: {
    url: "/admin/classroom/bindingORUnbinding",
    method: "post"
  },
  // 教室绑定的设备列表
  getClassroomDeviceList: {
    url: "/admin/classroom/bindingList",
    method: "get"
  },
  // 踢出教室
  quitClassroom: {
    url: "/admin/classroom/quit",
    method: "get"
  },
  // 删除教室
  deleteClassrooom: {
    url: "/admin/classroom/delete",
    method: "get"
  },
  // 查询教室列表
  getClassrooomList: {
    url: "/admin/classroom/list",
    method: "get"
  },

  /** 设备管理相关接口 **/
  // 查询设备列表
  getDeviceManageList: {
    url: "/admin/device/listDevice",
    method: "get"
  },
  // 添加设备
  addDevice: {
    url: "/admin/device/saveDevice",
    method: "post"
  },
  // 删除设备
  deleteDevice: {
    url: "/admin/device/delDevice",
    method: "post"
  },
  /** 教师管理相关接口 **/
  // 添加教师
  saveTeacherInfo: {
    url: "/admin/teacherManage/saveTeacherInfo",
    method: "post"
  },
  // 删除教师
  deleteTeacherInfo: {
    url: "/admin/teacherManage/deleteTeacherInfo",
    method: "post"
  },
  // 查询教师列表信息
  findTeacherInfos: {
    url: "/admin/teacherManage/findTeacherInfos",
    method: "get"
  },
  // 导入教师相关信息
  importTeacherInfos: {
    url: "/admin/teacherManage/importTeacherInfos",
    method: "post"
  },
  // 上传教师信息文件
  uploadTeacherDatas: {
    url: "/admin/teacherManage/uploadTeacherDatas",
    method: "post"
  }
}